import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GenerateGuidService } from '../../../../shared/generate-guid/generate-guid.service';
import { EquipmentFailureMode, FailurePattern } from '../../../../viewmodels/equipment/equipment-failure-mode';
import { FailureModeUserAcceptance } from '../../../../viewmodels/equipment/failure-mode-user-acceptance';
import { PlannedMaintenance, PlannedMaintenanceActivity } from '../../../../viewmodels/equipment/planned-maintenance';
import { UserAcceptancePlannedMaintenance } from '../../../../viewmodels/equipment/user-acceptance-planned-maintenance';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceAnalysisUserAcceptanceService {
  userAcceptanceAdded = new Subject();

  constructor(private guidService: GenerateGuidService) { }

  public addUserAcceptanceRecord(failureMode: EquipmentFailureMode, maintenance: PlannedMaintenance) {
    const userAcceptance = new FailureModeUserAcceptance();
    userAcceptance.id = this.guidService.newGuid();

    failureMode.maintenanceAnalysisUserAcceptanceId = userAcceptance.id;
    failureMode.userAcceptance = userAcceptance;

    if (maintenance !== null) {
      this.addPlannedMaintenanceToUserAcceptance(userAcceptance, maintenance);
    }

    this.updateUserAcceptanceMitigationStatus(failureMode);

    this.userAcceptanceAdded.next();
  }

  addPlannedMaintenanceToUserAcceptance(userAcceptance: FailureModeUserAcceptance, maintenance: PlannedMaintenance) {
    const plannedMaintenance = new UserAcceptancePlannedMaintenance();
    plannedMaintenance.id = maintenance.id;
    plannedMaintenance.reference = maintenance.reference;
    plannedMaintenance.activity = maintenance.activity;

    userAcceptance.plannedMaintenance.push(plannedMaintenance);
  }

  updateUserAcceptanceMitigationStatus(failureMode: EquipmentFailureMode) {
    failureMode.userAcceptance.isMitigated = false;

    Array.from(failureMode.userAcceptance.plannedMaintenance).some(currentPlannedMaintenance => {
      failureMode.userAcceptance.isMitigated = this.checkActivityFailurePatternMitigatesFailure(
        currentPlannedMaintenance.activity,
        failureMode.failurePattern
      );

      if (failureMode.userAcceptance.isMitigated) {
        return true;
      }
    });
  }

  checkActivityFailurePatternMitigatesFailure(
    selectedPlannedMaintenanceActivity: PlannedMaintenanceActivity,
    selectedFailurePattern: FailurePattern
  ): boolean {
    if (
      (selectedFailurePattern === FailurePattern.Bathtub ||
        selectedFailurePattern === FailurePattern.WearOut ||
        selectedFailurePattern === FailurePattern.Fatigue) &&
      (selectedPlannedMaintenanceActivity === PlannedMaintenanceActivity.OnCondition ||
        selectedPlannedMaintenanceActivity === PlannedMaintenanceActivity.FailureFinding)
    ) {
      return true;
    }

    if (
      (selectedFailurePattern === FailurePattern.InitialBreakinPeriod ||
        selectedFailurePattern === FailurePattern.Random ||
        selectedFailurePattern === FailurePattern.InfantMortality) &&
      selectedPlannedMaintenanceActivity === PlannedMaintenanceActivity.ScheduledDiscardOrRestoration
    ) {
      return true;
    }

    return false;
  }

  removePlannedMaintenanceFromUserAcceptance(plannedMaintenanceId: string, userAcceptance: FailureModeUserAcceptance) {
    const plannedMaintenanceIndex = userAcceptance.plannedMaintenance.findIndex(x => x.id === plannedMaintenanceId);

    if (plannedMaintenanceIndex !== -1) {
      userAcceptance.plannedMaintenance.splice(plannedMaintenanceIndex, 1);
    }
  }
}
